import { useEffect, useRef } from 'react';
import styles from './SizingModal.module.css';


const pantsMeasurements = [
  ['Pant Length', '15.4', '16.3', '17.1', '18.0'],
  ['Waistband Height', '2.0', '2.0', '2.0', '2.0'],
  ['1/2 Waist Circumference', '13.5', '14.5', '15.5', '16.5'],
  ['1/2 Hip Circumference', '22.7', '23.9', '25.1', '26.3'],
  ['Full Thigh Circumference', '27.8', '29.0', '30.2', '31.4'],
  ['Full Leg Opening', '27.0', '28.0', '29.0', '30.0'],
  ['Front Rise (incl. waist)', '11.5', '12.0', '12.5', '13.0'],
  ['Back Rise (incl. waist)', '13.7', '14.2', '14.7', '15.2'],
  ['Inseam', '4.6', '5.0', '5.4', '5.8'],
];

const shirtMeasurements = [
  ['Length', '24.875', '25.500', '26.125', '26.750'],
  ['Chest', '22.500', '23.500', '24.500', '25.500'],
  ['Collar width', '7.000', '7.250', '7.500', '7.750'],
  ['Sleeve length', '23.25', '23.5', '23.75', '24'],
];

const sizes = ['XS', 'S', 'M', 'L'];

function getMeasurements(productName) {
  const normalizedName = String(productName ?? '').trim().toLowerCase();
  if (normalizedName.includes('shirt') || normalizedName.includes('quarter-zip')) return shirtMeasurements;
  if (normalizedName.includes('short')) return pantsMeasurements;
  return null;
}

function SizeGuide({ product, selectedSize }) {
  const measurements = getMeasurements(product.name);

  if (!measurements) {
    return <p className={styles.sizingGuideUnavailable}>Sizing information is not available for this product.</p>;
  }

  return (
    <div className={styles.sizingGuideScroll}>
      <table>
        <caption>{product.name} measurements in inches</caption>
        <thead><tr><th scope="col">Measurement</th>{sizes.map((size) => <th key={size} scope="col" className={size === selectedSize ? styles.selectedSizeHeader : ''}>{size}</th>)}</tr></thead>
        <tbody>{measurements.map(([label, ...values]) => <tr key={label}><th scope="row">{label}</th>{values.map((value, index) => <td key={sizes[index]} className={sizes[index] === selectedSize ? styles.selectedSizeCell : ''}>{value}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
}

export default function SizingModal({ selection, close }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (selection && dialog && !dialog.open) dialog.showModal();
    document.body.classList.toggle('sizing-modal-open', Boolean(selection));
    return () => document.body.classList.remove('sizing-modal-open');
  }, [selection]);

  if (!selection) return null;

  return (
    <dialog ref={dialogRef} className={`${styles.sizingModal} ${styles.sizingGuide}`} aria-labelledby="sizing-modal-title" onClose={close} onClick={(event) => event.target === dialogRef.current && close()}>
      <div className={styles.sizingModalHeader}><div><p className={styles.sizingModalKicker}>Fit reference / inches</p><h2 id="sizing-modal-title">{selection.product.name} sizing</h2></div><button className={styles.sizingModalClose} type="button" onClick={close} aria-label="Close sizing guide">&times;</button></div>
      <div className={styles.sizingModalContent}><SizeGuide product={selection.product} selectedSize={selection.selectedSize} /></div>
    </dialog>
  );
}